module.exports = __webpack_public_path__ + "static/media/md-flashlight.473a1f65.svg";